import { render, staticRenderFns } from "./family-list.vue?vue&type=template&id=63dd35b1&scoped=true"
import script from "./family-list.vue?vue&type=script&lang=js"
export * from "./family-list.vue?vue&type=script&lang=js"
import style0 from "./family-list.vue?vue&type=style&index=0&id=63dd35b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd35b1",
  null
  
)

export default component.exports